import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Creates a new vendor invoice with files
 * @param {FormData} formData - FormData object containing all form fields and files
 * @returns {Promise} - API response
 */
export const createVendorInvoice = async (formData) => {
  try {
    const response = await apiClient.post('/vendorInvoiceManagement/invoice/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
